import React, {useCallback} from 'react';
import {UserEditForm, UserEditFormValues} from './UserEditForm';
import {useNavigate} from 'react-router-dom';
import {userSetUserType, useUserFromList} from '../../../../../store/user';
import {useDispatch} from 'react-redux';
import {trackUserTypeChanged} from '../../../../../tracking/tracking';
import {messageAdd, MessageTypes} from '../../../../../store/message';
import {fullName} from '../../../../../store/user/utils';
import {getUrlRoute, MRAppRoutes, useRoute} from '../../../../router/routes';
import AdminSpaceHeader from '../../common/AdminSpaceHeader/AdminSpaceHeader';
import AdminPage from '../../common/AdminPage/AdminPage';

const UserEdit: React.FC = () => {
  const {id} = useRoute<MRAppRoutes.USER_EDIT>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {user, notFound} = useUserFromList(id);
  if (notFound) {
    dispatch(messageAdd('User not found', MessageTypes.ERROR));
    navigate(getUrlRoute(MRAppRoutes.USER_LIST));
  }

  const handleSubmit = useCallback(
    (values: UserEditFormValues) => {
      const {userType} = values;
      const onSuccess = () => {
        dispatch(messageAdd(`${fullName(user!)} has been updated`, MessageTypes.SUCCESS));
        navigate(getUrlRoute(MRAppRoutes.USER_LIST));
      };
      if (userType === user!.userType) {
        onSuccess();
        return;
      }

      userSetUserType(dispatch, user!.id, userType).then(() => {
        trackUserTypeChanged();
        onSuccess();
      });
    },
    [dispatch, navigate, user],
  );

  return (
    <AdminPage style={{padding: '2rem'}} header={<AdminSpaceHeader />}>
      {user && <UserEditForm user={user} onSubmit={handleSubmit} />}
    </AdminPage>
  );
};

export default UserEdit;
